import { CancelRounded, SearchRounded } from "@mui/icons-material";
import classNames from "classnames";
import { InputHTMLAttributes, forwardRef } from "react";
import styles from "./css/SearchField.module.css";

interface SearchFieldProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  value: string;
  onChange: (value: string) => void;
  clearLabel?: string;
}

const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>(
  function SearchField(
    { value, onChange, clearLabel = "지우기", className, placeholder, ...rest },
    ref
  ) {
    return (
      <div className={classNames(styles.search, className)}>
        <SearchRounded className={styles.searchIcon} aria-hidden />
        <input
          ref={ref}
          type="search"
          enterKeyHint="search"
          className={styles.input}
          value={value}
          placeholder={placeholder}
          aria-label={rest["aria-label"] ?? placeholder}
          onChange={(e) => onChange(e.target.value)}
          {...rest}
        />
        {value.length > 0 && (
          <button
            type="button"
            className={styles.clear}
            aria-label={clearLabel}
            onClick={() => onChange("")}
          >
            <CancelRounded />
          </button>
        )}
      </div>
    );
  }
);

export default SearchField;
